import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { ShareCapitalService } from './service/share-capital.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { FinancialpositionService } from '../../financialposition/financialposition.service';

@Component({
  selector: 'app-share-capital',
  templateUrl: './share-capital.component.html',
  styleUrls: ['./share-capital.component.scss']
})
export class ShareCapitalComponent implements OnInit {
  SharecapitalFormgGroup: FormGroup;

  Grid_Total1: number;
  Grid_Total2: number;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;
  disablecapital: boolean
  valid: boolean = true;
  constructor(private FormBuilder: FormBuilder, private balanceSheetService: FinancialpositionService, private shareservice: ShareCapitalService, public commonService: CommonService, private Router: Router, private sidenav: SideNavService) {

  }

  ngOnInit() {
    debugger;
    //this.commonService.getIncomeStatementsHeaders();
    //this.createformgroup();
    //if (this.wizardrowslist.length > 0) {
    //  if (this.SharecapitalFormgGroup.get('Wizardrows')['controls'][0].controls['DescriptionShareType'].value == null || this.Sharecapital.get('Wizardrows')['controls'][0].controls['ShareClass_Id'].value == "")
    //    this.wizardrowslist.removeAt(0);
    //}
    //this.Getdata();
    //this.isJump = localStorage.getItem('isJump');



    debugger
    //this.getBalanceSheet()
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.createformgroup();
    this.wizardrowslist.clear();
    this.GetShareCapital();
    this.commonService.getNotesData();
    this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.SharecapitalFormgGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetShareCapital_LY()
      }
    })

    
  }
  BalanceSheetdata:any
  //getBalanceSheet() {
  //  this.balanceSheetService.getBalanceSheetFRS101(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
  //    debugger
  //    this.BalanceSheetdata=data
  //  })
  //  }
  createformgroup() {
    this.SharecapitalFormgGroup = this.FormBuilder.group({
      ShareCapitalId: new FormControl(),
      MasterId: new FormControl(),
      ShareCapitalSharePremiumSubtotal: new FormControl({ disabled: true, value: '' }),
      ShareCapitalSharePremiumSubtotal_LY: new FormControl({ disabled: true, value: '' }),
      ShareCapitalFreeøtextComment: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      Wizardrows: this.FormBuilder.array([this.FormBuilder.group({
        DetailsId: new FormControl(),
        SharecapitalId: new FormControl(),
        DescriptionShareType: new FormControl(),
        ShareClassName: new FormControl(),
        ShareCapitalSharePremiumSubtotal: new FormControl(),
        ShareCapitalSharePremiumSubtotal_LY: new FormControl(),
        CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
        CreatedDate: new FormControl(),
        ModifiedBy: new FormControl(),
        ModifiedDate: new FormControl(),
      })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        debugger;
        this.SharecapitalFormgGroup.reset();
        this.wizardrowslist.clear();
        this.SharecapitalFormgGroup.controls['APPeriodId'].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }



  GetShareCapital() {
    debugger;
    this.shareservice.getdata(this.SharecapitalFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      for (let i = 0; i < data.Wizardrows.length; i++) {
        this.wizardrowslist.push(this.FormBuilder.group({
          SharecapitalId: data.Wizardrows[i].SharecapitalId,
          DetailsId: data.Wizardrows[i].DetailsId,
          DescriptionShareType: data.Wizardrows[i].DescriptionShareType,
          ShareCapitalSharePremiumSubtotal: data.Wizardrows[i].ShareCapitalSharePremiumSubtotal?data.Wizardrows[i].ShareCapitalSharePremiumSubtotal:0,
          ShareCapitalSharePremiumSubtotal_LY: data.Wizardrows[i].ShareCapitalSharePremiumSubtotal_LY?data.Wizardrows[i].ShareCapitalSharePremiumSubtotal_LY:0,
          ShareClassName: data.Wizardrows[i].ShareClassName
        }));
      }
      this.SharecapitalFormgGroup.patchValue(data);
      if (localStorage.getItem("SubmitStatus") == "true") {
        this.SharecapitalFormgGroup.disable()
        this.disablecapital = true;
        this.SharecapitalFormgGroup.controls['Wizardrows'].disable()
      }
      this.SharecapitalFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

      this.CalculationsGrid()
    })
  }

  GetShareCapital_LY() {
    debugger;
    this.shareservice.getdata_LY(this.SharecapitalFormgGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      this.showBubbledata = data;
      this.SharecapitalFormgGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

      this.CalculationsGrid()
    })
  }

  On_Next() {
    debugger;

    if (this.Gridvalidations('next')) {
      this.shareservice.insertdetails(this.SharecapitalFormgGroup.getRawValue()).subscribe(data => {
        this.SharecapitalFormgGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Share capital", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'sharecapital') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.SharecapitalFormgGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Share capital", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  AddNew() {
    debugger;
    //var wizardrowslist = this.SharecapitalFormgGroup.controls['Wizardrows'] as FormArray;
    if (this.Gridvalidations()) {
      this.wizardrowslist.push(this.FormBuilder.group({ SharecapitalId: '', DescriptionShareType: '', ShareClassName: '', ShareCapitalSharePremiumSubtotal: '', ShareCapitalSharePremiumSubtotal_LY: '' }));
    }
    //  this.wizardrowslist.clear();

  }


  DeleteRow(index) {
    debugger;
    Swal.fire({
      title: 'Andica Accounts Production',
      text: 'Are you sure you want to delete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        this.wizardrowslist.removeAt(index);
        this.CalculationsGrid();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return false
      }
    })

  }

  Gridvalidations(from?:any) {
    debugger;
    if (this.commonService.AccountTemplateId == 11 && from=='next') {
        if (this.commonService.showControl == true) {
          if (+this.SharecapitalFormgGroup.controls['ShareCapitalSharePremiumSubtotal'].value != this.BalanceSheetdata.ShareCapital) {
            Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Balance Sheet account for the year " + this.commonService.StartYear + ".", 'warning');
            return false
          } else if (+this.SharecapitalFormgGroup.controls['ShareCapitalSharePremiumSubtotal_LY'].value != this.BalanceSheetdata.ShareCapital_LY) {
            Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Balance Sheet account for the year " + this.commonService.LastYear + ".", 'warning');
            return false
          } else
            return true
        } else {
          if (+this.SharecapitalFormgGroup.controls['ShareCapitalSharePremiumSubtotal'].value != this.BalanceSheetdata.ShareCapital) {
            Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Balance Sheet account for the year " + this.commonService.StartYear + ".", 'warning');
            return false
          } else
            return true
        }
    }
    if (this.wizardrowslist.length == 0)
      return true;
    //if (!this.wizardrowslist.value[this.wizardrowslist.length-1].DescriptionShareType) {
    //  Swal.fire("Andica Accounts Production", "Item description' must be completed.", 'info');
    //  return false;
    //}
    if (this.SharecapitalFormgGroup.value.Wizardrows.filter(x => x.ShareClassName == 'Ordinary').length > 5) {
      Swal.fire("Andica Accounts Production", "You have used more than 5 entries of Ordinary share class. Kindly remove / modify your entry.", "warning")
      return false
    }
    else if (this.SharecapitalFormgGroup.value.Wizardrows.filter(x => x.ShareClassName == "Preference").length > 5) {
      Swal.fire("Andica Accounts Production", "You have used more than 5 entries of Preference share class. Kindly remove / modify your entry.", "warning")
      return false
    }
    if (this.wizardrowslist.length) {
      var data = [];
      for (var j = 0; j < this.wizardrowslist.length; j++) {
        var v = this.SharecapitalFormgGroup.value.Wizardrows.filter(x => x.DescriptionShareType == this.wizardrowslist.value[j].DescriptionShareType)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", "warning");
          return false;
        }
        else if (this.SharecapitalFormgGroup.value.Wizardrows[j].DescriptionShareType == null || this.SharecapitalFormgGroup.value.Wizardrows[j].DescriptionShareType == "") {
          /* Swal.fire("Andica Accounts Production", 'Item description must be completed.', "warning");*/
          this.valid = false;
          return false;
        }
        else if (this.SharecapitalFormgGroup.value.Wizardrows[j].ShareClassName == null || this.SharecapitalFormgGroup.value.Wizardrows[j].ShareClassName == "") {
          //Swal.fire("Andica Accounts Production", 'Share class type must be completed.', "warning");
          this.valid = false;
          return false;
        }
        else {
          this.valid = true;
        }
      }
    }
  
    return true;
  }

  CalculationsGrid() {
    debugger;
    this.Grid_Total1 = 0;
    this.Grid_Total2 = 0;
    for (var i = 0; i < this.wizardrowslist.length; i++) {
      this.Grid_Total1 = this.Grid_Total1 + +this.wizardrowslist.value[i].ShareCapitalSharePremiumSubtotal;
      this.Grid_Total2 = this.Grid_Total2 + +this.wizardrowslist.value[i].ShareCapitalSharePremiumSubtotal_LY;
    }
    this.SharecapitalFormgGroup.controls['ShareCapitalSharePremiumSubtotal'].setValue(this.Grid_Total1)
    this.SharecapitalFormgGroup.controls['ShareCapitalSharePremiumSubtotal_LY'].setValue(this.Grid_Total2)
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.SharecapitalFormgGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.On_Next()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

  get wizardrowslist() {
    return this.SharecapitalFormgGroup.get('Wizardrows') as FormArray;
  }

  validate() {
    if (this.SharecapitalFormgGroup.value.Wizardrows.filter(x => x.ShareClassName == 'Ordinary').length > 5) {
      Swal.fire("Andica Accounts Production", "You have used more than 5 entries of Ordinary share class. Kindly remove / modify your entry.", "warning")
      return false
    }
    if (this.SharecapitalFormgGroup.value.Wizardrows.filter(x => x.ShareClassName == "Preference").length > 5) {
      Swal.fire("Andica Accounts Production", "You have used more than 5 entries of Preference share class. Kindly remove / modify your entry.", "warning")
      return false
    }
  }
}

